import { Stats } from '../../../common/components'
import { useCostUtils, useQueryFilters, useTimeStatsQuery } from '../../../common/hooks'
import { formatBuszAppData } from '../../../common/utils/dataFormatting'
import { formatNumber } from '../../../common/utils/numberFormatting'
import useBusinessAppsFilters from '../useBusinessAppsFilters'
import { getSelectedDateCount } from '../utils'

const TimeStats = () => {
  const { formatCost } = useCostUtils()
  const { min_date, max_date } = useQueryFilters()
  const { isIgnoreWeekendsActive } = useBusinessAppsFilters()

  const { dataList, dailyComputerCountSum, isLoadingWindowUsage, isLoadingComputerCount, error } =
    useTimeStatsQuery('application')

  // Calculate derived values from the hook data
  const timeH = dataList?.reduce((sum: number, val: any) => sum + val.time_h, 0) ?? 0
  const [teams, annualCost, visits] = dataList ? formatBuszAppData(dataList) : [0, 0, 0]
  const dailyHours = dailyComputerCountSum ? timeH / dailyComputerCountSum : 0
  const selectedDateCount = getSelectedDateCount(min_date, max_date, isIgnoreWeekendsActive)

  const statData = [
    [
      {
        value: formatCost(annualCost),
        label: 'Annualized cost',
      },
      {
        value: formatNumber(timeH, 1),
        label: 'Total hours',
      },
      {
        value: formatNumber(dailyHours),
        label: 'Daily hours per computer',
        isLoading: isLoadingComputerCount,
      },
    ],
    [
      {
        value: formatNumber(visits, 1),
        label: 'Total visits',
      },
      {
        value: formatNumber(teams, 1),
        label: 'Teams',
      },
      {
        value: formatNumber((dailyComputerCountSum ?? 0) / selectedDateCount, 10),
        label: 'Average daily computers',
        isLoading: isLoadingComputerCount,
      },
    ],
  ]

  if (error) {
    console.error('Time stats error:', error)
  }

  return (
    <div className='flex flex-col gap-2'>
      <Stats data={statData[0]} isLoading={isLoadingWindowUsage} />
      <Stats data={statData[1]} isLoading={isLoadingWindowUsage} />
    </div>
  )
}

export default TimeStats

